module.exports = __webpack_public_path__ + "img/nivelacion_de_firmes_y_losas.e7588e75.png";